"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var PayResponse;
(function (PayResponse) {
    var Pay = (function (_super) {
        __extends(Pay, _super);
        function Pay() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.description = undefined;
            _this.externalId = undefined;
            _this.status = undefined;
            return _this;
        }
        return Pay;
    }(BaseModel_1["default"]));
    PayResponse.Pay = Pay;
})(PayResponse = exports.PayResponse || (exports.PayResponse = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/pay.js
// module id = ../model/dist/models/pay.js
// module chunks = main